module.exports = ".table-balance tbody:nth-of-type(odd) {\r\n    background-color:#F5F5F5;\r\n}\r\n\r\n.table-div {\r\n    width: 100%;\r\n    overflow-x: auto;\r\n}\r\n\r\n@media (min-width: 992px) {\r\n    .table-div {\r\n        width: calc(50% - 0.5rem);\r\n    }\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dashboard-bookkeeper/dashboard-bookkeeper.component.css
// module id = ./src/app/components/dashboard-bookkeeper/dashboard-bookkeeper.component.css
// module chunks = main